import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface ISummaryProps {
  label: React.ReactNode;
  testId?: string;
}

export function Summary({ label, testId, children }: React.PropsWithChildren<ISummaryProps>) {
  return (
    <div className={styles['container']} data-testid={testId}>
      <UIText1 color="gray60_100" whiteSpace="nowrap">
        {label}
      </UIText1>
      {children}
    </div>
  );
}
